const validateRUT = (rut) => {
    if (!rut) return false;
    rut = rut.replace(/[.-]/g, '');
    if (rut.length < 8 || rut.length > 9) return false;

    let body = rut.slice(0, -1);
    let dv = rut.slice(-1).toUpperCase();

    let sum = 0;
    let mul = 2;
    for (let i = body.length - 1; i >= 0; i--) {
        sum += body[i] * mul;
        mul = (mul == 7) ? 2 : mul + 1;
    }

    let expectedDV = 11 - (sum % 11);
    if (expectedDV == 11) expectedDV = '0';
    if (expectedDV == 10) expectedDV = 'K';

    return dv == expectedDV.toString();
}

export default validateRUT;
